<template>
  <section class="bg-primary">
    <div class="container ">
      
      <ContentsPageTitle
        title="Chemical Recycling"
        description="Chemical recycling of plastics mean we convert plastic waste (Post consumer recycle PCR)
          into new material by breaking down polymers into building block to produce new plastic resins. Hence, quality
          of material is very close to virgin material and possible for food application."
      />

    </div>
  </section>



  <!-- PRODUCT DETAIL PAGE -->
  <section class="section-product-detail-page">
    <div class="container">
      <div class="page-content">

        <div class="properties-applications-box">
          <ContentsTextWithImage
            title="Properties"
            image-url="/pages/products/sustainable-plastics/chem01.jpg"
            :contents="[
              'Circular economy is not just buzz word, but many global companies are demanding for reuse resources. We provide circular solution that helps environment by keeping PET bottle and other plastic waste from both land and sea to upcycling with proprietary technology to get new virgin quality resin. This is also possible to use recycled plastics for food contact application.'
            ]"
            is-reverse="true"
            left-width="43.444%"
            right-width="56.275%"
          />
  
          <ContentsTextWithImage
            title="Applications"
            image-url="/pages/products/sustainable-plastics/chem02.jpg"
            :contents="[
              'Textile, toothbrush bristles, food & beverage packaging, cosmetic, consumer electronics, and auto parts and any other applications that require properties or original material.'
            ]"
            left-width="43.421%"
            right-width="56.275%"
          />
        </div>

      </div>


    </div>
  </section>

  <section class="section-product-detail-page section-our-partners">
    <div class="container">
      <div class="page-content">

        <ContentsOurPartners
          :is-remove-contact-text="true"
          :partners="[
            {
              name: 'Sabic',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/sustainable-plastics/Screen-Shot-2565-05-19-at-15.08.54.png',
              },
            },
          ]"
        />

      </div>
    </div>
  </section>

</template>
<script setup lang="ts">
useHead({
  title:'Chemical Recycling - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>
.properties-applications-box {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
}

.section-our-partners .page-content {
  padding: 48px 0 60px;
}
</style>